import { render, staticRenderFns } from "./faceSecond.vue?vue&type=template&id=9a19da88&scoped=true"
import script from "./faceSecond.vue?vue&type=script&lang=js"
export * from "./faceSecond.vue?vue&type=script&lang=js"
import style0 from "./faceSecond.vue?vue&type=style&index=0&id=9a19da88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a19da88",
  null
  
)

export default component.exports